import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { ConfigActions } from './config-actions';
import { IConfigState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IConfigActionsProps {
  readonly warning: boolean;
}

export interface IConfigActionsStateProps extends IConfigActionsProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type IConfigActionsConnectProps = IConfigActionsStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState, props: IConfigActionsProps): IConfigActionsStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    ...props
  };
}

export const ConfigActionsContainer: React.ComponentClass<IConfigActionsProps>
  = ReactRedux.connect(mapStateToProps)(ConfigActions);
